import { render, staticRenderFns } from "./InitializeSampleDataButton.vue?vue&type=template&id=5d04aaca&"
import script from "./InitializeSampleDataButton.vue?vue&type=script&lang=js&"
export * from "./InitializeSampleDataButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports